<div class="bg">
  <div class="container-fluid">
    <div class="row">
      <div class="left-contents order-sm-2 order-2">
        <div class="contents">
          <div class="sp-container">
            <div class="sp-content">
              <div class="sp-globe"></div>
              <h2 class="frame-1">
                NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
              </h2>
            </div>
          </div>

          <p id="text">
            Artificial intelligence is leaving a noted mark in every walk of
            life. What if you could harvest its power to change your life for
            the best? ONPASSIVE gives you the opportunity to make a fresh start
            in your life through an innovating digital marketing platform that
            is backed up by AI. Join ONPASSIVE to see daily returns in your
            pockets sitting at your home.
          </p>
        </div>
      </div>

      <div class="circle p-4 order-sm-1 order-1">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(october6)/images/earth.gif"
          width="100%"
          alt="earth"
        />
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(october6)/images/logo.png"
            alt="logo"
          />
        </div>
      </div>
      <div class="w-100 d-lg-none title-top">
        <h3 class="mt-4 mb-5 text-center">LAUNCHING SOON</h3>
      </div>
      <div class="d-none d-lg-block w-100">
        <svg viewBox="0 0 100 200">
          <defs>
            <linearGradient id="gradient" x1="0" x2="0" y1="0" y2="1">
              <stop offset="20%" stop-color="#1af7ff"></stop>
              <stop offset="80%" stop-color="#08a6a8"></stop>
            </linearGradient>
            <pattern
              id="wave"
              x="0"
              y="0"
              width="120"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <path
                id="wavePath"
                d="M-40 9 Q-30 7 -20 9 T0 9 T20 9 T40 9 T60 9 T80 9 T100 9 T120 9 V20 H-40z"
                mask="url(#mask)"
                fill="url(#gradient)"
              >
                <animateTransform
                  attributeName="transform"
                  begin="0s"
                  dur="1.5s"
                  type="translate"
                  from="0,0"
                  to="40,0"
                  repeatCount="indefinite"
                ></animateTransform>
              </path>
            </pattern>
          </defs>
          <text
            text-anchor="middle"
            x="52"
            y="12"
            font-size="7"
            fill="url(#wave)"
            fill-opacity="0.9"
            data-aos="fade-left"
          >
            LAUNCHING SOON
          </text>
          <text
            text-anchor="middle"
            x="52"
            y="12"
            font-size="7"
            fill="url(#gradient)"
            fill-opacity="0.5"
            data-aos="fade-left"
          >
            LAUNCHING SOON
          </text>
        </svg>
      </div>
      <div class="video order-sm-3 order-3">
        <div class="video_box">
          <video
            id="my-video"
            controls
            poster="{{ myLinksS3URL }}images/Image0231.png"
            autoplay="true"
            width="100%"
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video2.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>

      <div class="btn-block">
        <a
          href="/registration/user?reg={{ userId }}"
          name="regform"
          target="_blank"
          rel="noopener"
          class="animated-button1"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Become a Founder Now
        </a>
      </div>
    </div>
  </div>
</div>
